var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24899_4890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.49919 4.5001V6.5001M6.49919 8.5001H6.5046M5.57294 1.9301L0.985021 9.0001C0.890428 9.15131 0.840378 9.32275 0.839848 9.49736C0.839318 9.67197 0.888328 9.84367 0.982002 9.99537C1.07568 10.1471 1.21075 10.2735 1.37378 10.362C1.53681 10.4506 1.72212 10.4982 1.91127 10.5001H11.0871C11.2763 10.4982 11.4616 10.4506 11.6246 10.362C11.7876 10.2735 11.9227 10.1471 12.0164 9.99537C12.11 9.84367 12.1591 9.67197 12.1585 9.49736C12.158 9.32275 12.1079 9.15131 12.0134 9.0001L7.42544 1.9301C7.32887 1.78316 7.19291 1.66166 7.03067 1.57734C6.86842 1.49303 6.68538 1.44873 6.49919 1.44873C6.313 1.44873 6.12995 1.49303 5.96771 1.57734C5.80546 1.66166 5.6695 1.78316 5.57294 1.9301Z",
    stroke: "#C13245",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24899_4890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.250613d1.svg";
export { ForwardRef as ReactComponent };